import React, { useCallback } from 'react';
import cn from 'classnames';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { clearSnackbar, snackBarConfig } from 'reducers/ui';
import { useDispatch, useSelector } from 'react-redux';
import Slide from '@material-ui/core/Slide';
import { useTranslation } from 'react-i18next';

function transitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiPaper-root': {
      backgroundColor: '#4caf50 !important',
      color: 'white !important',
      fontWeight: '400',
    },
    '& .MuiIconButton-label': {
      color: 'white !important',
    },
  },
  snackbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '1rem',
    fontSize: '15px',
    width: '300px',
    color: 'white',
    borderRadius: '5px',
    '& > div': {
      flex: '0 0 300',
    },
    paddingRight: '20px',
  },
  cross: { height: 'auto', position: 'absolute', top: '0', right: '0' },
  success: {
    backgroundColor: theme.palette.success.main,
  },
  warn: {
    backgroundColor: theme.palette.warning.main,
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
}));

const SnackBar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const clearSnackBar = useCallback(() => dispatch(clearSnackbar()), [
    dispatch,
  ]);
  const snackbarConfig = useSelector(state => snackBarConfig(state));
  const { t } = useTranslation();
  if (snackbarConfig.open) {
    transitionLeft();
  }
  const handleClose = (_, reason) => {
    // This will prevent snackbar to clear away if any component re-renders
    if (reason === 'clickaway') {
      return;
    }
    clearSnackBar();
  };

  return (
    <Snackbar
      className={classes.root}
      anchorOrigin={snackbarConfig.position}
      open={snackbarConfig.open}
      autoHideDuration={snackbarConfig.autoHideDuration}
      onClose={handleClose}
      TransitionComponent={transitionLeft}
      key={transitionLeft.name}
    >
      <div
        onClick={handleClose}
        className={cn(classes.snackbar, classes[snackbarConfig.type])}
      >
        <div> {t(snackbarConfig.message)}</div>
        <div className={classes.cross}>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
    </Snackbar>
  );
};

export default React.memo(SnackBar);
